import React from "react";
import { Box } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import SearchInput from "app/components/SearchInput";
import QuestionTypesDropdown from "app/components/QuestionTypesDropdown";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import EditorsSelect from "app/components/EditorSelect";
import { LEFT_SPACING, QUESTION_TYPES } from "utils/constants";
import CustomizeQuestionDropdownDropdown from "app/components/CustomizeQuestionDropdown";
import { allEditorOption } from "app/components/EditorSelect/helper";

const Header = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const searchParams  = useSearchParams();
  const questionType = searchParams?.[0]?.get("type")  as QUESTION_TYPES | undefined;;
  const editorParam = searchParams?.[0]?.get("user");
  const params = new URLSearchParams(window.location.search);
  const isCustomQuestion = params.get("isCustomQuestion") == 'true'
  const setQuestionSearchQuery = (search: string) => {
    if (search.toLowerCase() == "all") {
      params.set("type", "");
    } else {
      params.set("type", search);
    }
    navigate(`?${params.toString()}`);
  };




  const setEditorSearchQuery = (search: string) => {
    if (search.toLowerCase() == "all") {
      params.set("user", "");
    } else {
      params.set("user", search);
    }
    navigate(`?${params.toString()}`);
  };
  const setCustomizeQuestionSearchQuery = (val: string) => {
    if (val == "No") {
      params.delete("isCustomQuestion");
    } else {
      params.set("isCustomQuestion", "true");
    }
    navigate(`?${params.toString()}`);
  };

  return (
    <Grid2
      container
      spacing={2}
      md={12}
      sx={{ marginTop: "-32px" }}
      paddingLeft={LEFT_SPACING}
    >
      <Grid2 xs={3}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <SearchInput provisionLabel />
        </Box>
      </Grid2>
      {!isCustomQuestion && 
      <Grid2 xs={2}>
        <QuestionTypesDropdown value={questionType} onChange={(v) => setQuestionSearchQuery(v)} />
      </Grid2>}
      {!isCustomQuestion &&  <Grid2 xs={6} md={3}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            height: "100%",
          }}
        >
          <EditorsSelect
            label={t("COMMON.LABELS.EDITOR_NAME")}
            isFieldReq={false}
            backgroundColor="#F3F6F8"
            borderWidth={0}
            onChange={(e) => setEditorSearchQuery(e?.value || "")}
            value={editorParam ? {value: editorParam, label: ''} : undefined}
          />
        </Box>
      </Grid2>}

        <Grid2 xs={6} md={3}>
          <Grid2 xs={2}>
            <CustomizeQuestionDropdownDropdown
              isCustomQuestion={isCustomQuestion}
              onChange={(v) => setCustomizeQuestionSearchQuery(v)}
            />
          </Grid2>
        
        </Grid2>
  
    </Grid2>
  );
};

export default Header;
